import {Injectable} from '@angular/core';
import {ObbBuilder} from './collision/obb-builder.service';

interface Config {
  materialVisibleConstraint?: boolean;
  distanceConstraint?: boolean;
}

@Injectable()
export class RayHelperService {

  constructor() {
  }

  intersectObjectsObb(ray, objects, config: Config = {}) {

    config = config || {};

    var obj,
      obb,
      point,
      i = 0,
      intersection = [],
      containPoint,
      distance;

    for (; i < objects.length; i++) {
      obj = objects[i];

      // dont count object with material.visible = false;
      if (config.materialVisibleConstraint && obj.material && obj.material.visible === false)
        continue;

      obb = new ObbBuilder().build(obj);
      point = obb.intersectRay(ray);
      containPoint = obb.isPointContained(ray.origin);

      if (point && !containPoint) {

        distance = containPoint ? 0 : point.distanceTo(ray.origin);

        if (config.distanceConstraint && distance > config.distanceConstraint)
          continue;

        intersection.push({
          object: obj,
          point: containPoint ? ray.origin.clone() : point,
          distance: distance
        });
      }
    }

    intersection.sort(function (a, b) {
      return a.distance - b.distance;
    });

    return intersection;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/ray-helper.service.ts